<script setup lang="ts">
  import { useAuthenticated } from '@othercommerce/foundation';

  const authenticated = useAuthenticated();
</script>
<template>
  <div class="header-account">
    <template v-if="!authenticated">
      <RouterLink :href="$route('web.account.session.create')" class="header-account__item" primary>
        {{ $t('SHOP.AUTH.ACTION.SIGN_IN') }}
      </RouterLink>
      <span aria-hidden="true">
        |
      </span>
      <RouterLink :href="$route('web.account.register.create')" class="header-account__item">
        {{ $t('SHOP.AUTH.ACTION.SIGN_UP') }}
      </RouterLink>
    </template>
    <template v-else>
      <RouterLink :href="$route('web.account.show')" class="header-account__item">
        <SfIconPersonCircle aria-hidden="true" />
        {{ $t('SHOP.COMMON.ACTION.ACCOUNT') }}
      </RouterLink>
    </template>
  </div>
</template>
<style lang="scss" scoped>
  .header-account {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;

    &__item {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    a {
      height: 100%;
      text-decoration: underline;
      text-decoration-color: transparent;
      transition: text-decoration-color 0.2s ease-out;
    }

    @media(hover: hover) {
      a:hover {
        text-decoration-color: var(--primary-color);
      }
    }
  }
</style>
